module.exports = __webpack_public_path__ + "img/Geological_Survey_of_Finland_GTK-300x91.217fedf2.png";